import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Copy, Mail, MessageCircle, MessageSquare, Loader2 } from "lucide-react";
import { toast } from "sonner";

const digits = (p) => (p || "").replace(/[^0-9]/g, "");

export const InviteParentDialog = ({ parent, onClose }) => {
  const [inv, setInv] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setInv(null); }, [parent]);
  const create = async (send_email) => {
    setBusy(true);
    try { const { data } = await api.post(`/admin/parents/${parent.id}/invite`, { send_email }); setInv(data); if (send_email) toast[data.emailed ? "success" : "error"](data.emailed ? `Invite emailed to ${data.email}` : "Email could not be sent — copy or text the link instead"); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  const copy = async () => { try { await navigator.clipboard.writeText(inv.message); toast.success("Invite message copied"); } catch { toast.error("Copy failed — select the text manually"); } };
  const phone = digits(inv?.phone || parent?.phone);
  return (
    <Dialog open={!!parent} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="invite-parent-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy">Invite {parent?.name} to claim their account</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Creates a one-time link (valid 7 days) where the parent sets their own password and sees their Explorer's profile. A new link cancels any older one.</p>
        {!inv ? (
          <div className="flex flex-wrap gap-2">
            <Button disabled={busy || !parent?.email} onClick={() => create(true)} className="rounded-full bg-turquoise text-navy font-bold" data-testid="invite-email-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Mail className="w-4 h-4 mr-1" />Email invite</>}</Button>
            <Button disabled={busy} variant="outline" onClick={() => create(false)} className="rounded-full" data-testid="invite-link-btn"><MessageSquare className="w-4 h-4 mr-1" />Get link to text</Button>
          </div>
        ) : (
          <div className="space-y-3" data-testid="invite-result">
            <textarea readOnly value={inv.message} rows={4} className="w-full text-xs rounded-xl border border-slate-200 p-3 text-slate-600" data-testid="invite-message" />
            <div className="flex flex-wrap gap-2">
              <Button size="sm" variant="outline" onClick={copy} className="rounded-full" data-testid="invite-copy"><Copy className="w-4 h-4 mr-1" />Copy</Button>
              <a href={`https://wa.me/${phone}?text=${encodeURIComponent(inv.message)}`} target="_blank" rel="noreferrer"><Button size="sm" className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="invite-whatsapp"><MessageCircle className="w-4 h-4 mr-1" />WhatsApp</Button></a>
              <a href={`sms:${phone}?&body=${encodeURIComponent(inv.message)}`}><Button size="sm" variant="outline" className="rounded-full" data-testid="invite-sms"><MessageSquare className="w-4 h-4 mr-1" />Text (SMS)</Button></a>
              {!inv.emailed && parent?.email && <Button size="sm" variant="outline" disabled={busy} onClick={() => create(true)} className="rounded-full" data-testid="invite-email-after"><Mail className="w-4 h-4 mr-1" />Email it</Button>}
            </div>
            {!phone && <p className="text-[11px] text-amber-600">No phone number on file — WhatsApp/SMS will ask you to pick a contact.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
